import { render, staticRenderFns } from "./refAddGOST2FTDialog.vue?vue&type=template&id=889104fe"
import script from "./refAddGOST2FTDialog.vue?vue&type=script&lang=js"
export * from "./refAddGOST2FTDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports